import { FC } from 'react';
import {
  Modal,
  ModalBody,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Text,
  Button,
} from '@chakra-ui/react';

export interface InactiveInviteDialogProps {
  open: boolean;
  close: () => void;
  message: string;
}

export const InactiveInviteDialog: FC<InactiveInviteDialogProps> = ({
  open,
  close,
  message,
}) => (
  <Modal isOpen={open} onClose={close} data-testid="dialog">
    <ModalOverlay />
    <ModalContent>
      <ModalHeader data-testid="dialog-title" title="Inactive Invite">
        Inactive Invite
      </ModalHeader>
      <ModalBody data-testid="dialog-content">
        <Text fontSize="md" wordBreak="break-word">
          {message}
        </Text>
      </ModalBody>
      <ModalFooter data-testid="dialog-actions">
        <Button onClick={close}>Close</Button>
      </ModalFooter>
    </ModalContent>
  </Modal>
);
